import routerOptions0 from "/codebuild/output/src1846049551/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@24.3.0_db0@0.3.2_eslint@9.34.0_jiti@2.5.1_7c8716e6ef1c31dc1a8610346cf79e0d/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}